var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalloonOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 30",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#ED7B2F",
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#000",
    d: "M10 26A6 2 0 1 0 10 30A6 2 0 1 0 10 26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ED7B2F",
    x: 9,
    y: 18,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 7,
    y: 7,
    width: 6,
    height: 6,
    rx: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonOrange);
export default __webpack_public_path__ + "static/media/balloon-orange.37f52e969f1d06ac7f3f3d98312285da.svg";
export { ForwardRef as ReactComponent };